import { useCallback, useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Drawer, Typography } from 'antd'
import { DataList } from '@/Core/UI/DataList'

import { LoadFavoritesListTask } from '../Tasks/LoadFavoritesListTask'
import { favoritesManager } from '../Stores/FavoritesManager'
import { FavoritesListItem } from './FavoritesListItem'
import { OpenResourceCardTask } from '@/Core/Tasks/Resources/OpenResourceCardTask'

import './FavoritesDrawer.css'

export const FavoritesDrawer = observer(() => {
    const { isDrawerOpen, favorites, isLoadingFirstPage, isFavoritesLoading } = favoritesManager

    const lockRef = useRef(false)

    const loadFirstPage = useCallback((extraParams = {}) => {
        lockRef.current = false

        favoritesManager.setPagination({ page: 1, total: 0 })
        favoritesManager.setFavorites([])

        LoadFavoritesListTask({
            searchParams: {
                page: 1,
                ...extraParams,
            },
        })
    }, [])

    useEffect(() => {
        if (isDrawerOpen) {
            loadFirstPage()
        }
    }, [isDrawerOpen])

    return (
        <Drawer
            size={414}
            title="Обране"
            open={isDrawerOpen}
            className="favorites-drawer"
            styles={{
                header: {
                    padding: '5px 16px',
                    boxShadow: 'none',
                },
                body: {
                    padding: '0 0 24px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
            onClose={() => favoritesManager.setIsDrawerOpen(false)}
        >
            <DataList
                itemLayout="vertical"
                loading={isLoadingFirstPage}
                dataSource={favorites}
                locale={{ emptyText: 'Немає повідомлень' }}
                renderItem={(item) => {
                    return (
                        <FavoritesListItem
                            item={item}
                            onClick={() => {
                                favoritesManager.setIsDrawerOpen(false)
                                OpenResourceCardTask({
                                    resource: item.entityCode,
                                    primaryFieldValue: item.entityUuid,
                                })
                            }}
                        />
                    )
                }}
                style={{ padding: 25 }}
            />

            {isFavoritesLoading && (
                <div style={{ padding: 12, textAlign: 'center' }}>
                    <Typography.Text type="secondary">Завантаження…</Typography.Text>
                </div>
            )}
        </Drawer>
    )
})
